import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DateTimeFormatter } from "@core/format";
import { EllipsisText, factory, Stack, Text, useProps, useStyles } from "@coveord/plasma-mantine";
import classes from "./LastModificationCell.module.css";
var defaultProps = {
    renderEmail: function(param) {
        var children = param.children;
        return children;
    }
};
export var LastModificationCell = factory(function(_props, ref) {
    var props = useProps("LastModificationCell", defaultProps, _props);
    var classNames = props.classNames, styles = props.styles, style = props.style, className = props.className, vars = props.vars, email = props.email, renderEmail = props.renderEmail, lastModified = props.lastModified, others = _object_without_properties(props, [
        "classNames",
        "styles",
        "style",
        "className",
        "vars",
        "email",
        "renderEmail",
        "lastModified"
    ]);
    var getStyles = useStyles({
        name: "LastModificationCell",
        classes: classes,
        vars: vars,
        classNames: classNames,
        className: className,
        style: style,
        styles: styles,
        props: props
    });
    return /*#__PURE__*/ _jsxs(Stack, _object_spread_props(_object_spread({
        ref: ref,
        gap: 0
    }, getStyles("root", {
        style: style,
        styles: styles,
        className: className,
        classNames: classNames
    }), others), {
        children: [
            email ? renderEmail({
                children: /*#__PURE__*/ _jsx(EllipsisText, _object_spread_props(_object_spread({
                    classNames: {
                        text: classes.emailText
                    }
                }, getStyles("email", {
                    styles: styles,
                    classNames: classNames
                })), {
                    children: email
                })),
                email: email
            }) : null,
            /*#__PURE__*/ _jsx(Text, _object_spread_props(_object_spread({}, getStyles("lastModified", {
                styles: styles,
                classNames: classNames
            })), {
                children: DateTimeFormatter.calendar.format(lastModified)
            }))
        ]
    }));
});

//# sourceMappingURL=LastModificationCell.js.map